import Vue from 'vue';
import Photos from '@global/components/product_vue/photos'; // 商品圖片
import Recommend from '@page/productPage/components/Recommend.vue'; // 商品圖片
import Price from '@global/components/product_vue/Price'; // 呈現價格
import ColorButton from '@global/components/product_vue/ColorButton'; // 切換顏色按鈕
import Select from '@global/components/global/Select_vue'; // 選擇尺寸下拉選單
import Quantity from '@global/components/product_vue/Ui_quantity'; // 選擇購買數量
import BuyButton from '@global/components/product_vue/BuyButton'; // 選擇購買數量
import Ootd from '@page/productPage/components/Ootd.vue'; // 員工穿搭
import ProductInfo from '@global/components/product_vue/ProductInfo'; // 產品注意事項說明
import WhishlistBtn from '@global/components/product_vue/whishlistBtn_vue'; // 加入收藏
import imgTransfer from '@global/helpers/imgTransfer';
import AlertDialog from '@global/helpers/alertDialog';
import modal from 'bootstrap/js/dist/modal';
import axios from 'axios';
import Addon from '@page/productPage/js/addon';
import store from '@global/components/store/index';
import $ from 'jquery';
import { fireShopContentView } from '@global/gtm/product';

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

function RenderProductPageContent() {
  const productPageContent = new Vue({
    el: '#product-render',
    name: 'ProductPage',
    store,
    components: {
      Photos,
      Price,
      ColorButton,
      Select,
      Quantity,
      BuyButton,
      Ootd,
      ProductInfo,
      Recommend,
      WhishlistBtn,
      Addon,
    },
    data: {
      CustomMarketID: window.CustomMarketID.substring(0, window.CustomMarketID.indexOf('CL')),
      theProductDataNew: {},
      colorIndex: 0, // 當前顯示的顏色在JSON中的序號,
      colorID: window.CustomMarketID.substring(
        window.CustomMarketID.indexOf('CL') + 2,
        window.CustomMarketID.indexOf('SZ'),
      ),
      barcode: '', // 含色碼與尺寸碼的完整八扣，預設一進來是未選取Size 故設定為空自串 //*****
      sizeName: '',
      sizeIndex: -1, // 當前尺寸序號，以網址判斷，沒有的話-1
      sizeID: '',
      sizeData: [],
      buyAmount: 1, // 當前購買數量 預設1
      totalQty: 0,
      ones: true, // 第一次觸發componentDidUpdate改為 false
      isPreOrderProduct: false,
      isFuture: false,
      futureTime: [],
      photoSizeLogic: '|',
      photoSizeLogic_2: '_w136_h174|',
      NowMyEquipment: window.nowEnv.NowMyEquipment,
      NowMyStorage: window.nowEnv.NowMyStorage,
      productName: '',
      subtitle: '',
      sizeReportData: '',
      todayViewDataAry: [],
      todayViewBarcodes: [],
      sizeSelectOptions: [],
      theColorPhotoAry: [],
      theColorZoomAry: [],
      theColorStaffAry: [],
      theColorStaffZoomAry: [],
      categoryListData: [],
      isFavorite: false,
      favoriteState: [],
      sizeReportOpened: false,
      nowColorImage: '',
      aqIsLoad: window.aqIsLoad,
      careReportOpen: false,
      activeTabName: 'desc',
      carAddMainItem: false,
    },
    computed: {
      nowText() {
        return this.barcode === ''
          ? null
          : `${this.sizeName}${this.isPreOrderProduct ? ' (預)' : ''}`;
      },
      bonusText() {
        const startTime = new Date(2024, 5, 13, 10, 0, 0).getTime();
        const endTime = new Date(2024, 5, 16, 19, 59, 59).getTime();
        const now = new Date().getTime();
        if (now >= startTime && now <= endTime) {
          return true;
        }
        return false;
      },
    },
    created() {
      this.getData();
    },
    mounted() {
      if (!this.NowMyEquipment) {
        setTimeout(() => {
          $('.product-content.product-content--pdpage').css(
            'min-height',
            $('.product-menu').height(),
          );
        }, 0);
        $('.product-details').stick_in_parent();
        $('.product-menu').stick_in_parent();
        setTimeout(() => {
          $('.product-details').trigger('sticky_kit:recalc');
        }, 2000);
      }
      $('#sizeGuide').modal('hide');
    },
    update() {
      if (this.ones === true) {
        if (!this.NowMyEquipment) {
          setTimeout(() => {
            $('.product-content.product-content--pdpage').css(
              'min-height',
              $('.product-menu').height(),
            );
          }, 0);
          $('.product-details').stick_in_parent();
          $('.product-menu').stick_in_parent();
        }
        this.ones = false;
      }
    },
    methods: {
      getData() {
        axios
          .get(`${API_URL.MARKET_CONTENT}?CustomMarketID=${window.CustomMarketID}`)
          .then((response) => {
            const res = response.data;

            if (res.Code === 200) {
              this.productName = res.Response.Name;
              this.theProductDataNew = res.Response;
              this.subtitle = res.Response.SubTitle;
              this.initFavoriteState();
              this.initColorIndex();
              this.sizeSelectOptions = this.createSizeSelectOptions(
                res.Response.Colors[this.colorIndex].Specs,
              );
              // 如果是 Free Size
              if (
                this.sizeSelectOptions[0].text === 'F' ||
                this.sizeSelectOptions[0].text === 'F (預)'
              ) {
                this.onChangeSize(res.Response.Colors[this.colorIndex].Specs[0]);
                this.handleChangeSize(res.Response.Colors[this.colorIndex].Specs[0].Barcode);
              }

              return res.Response;
            }
            AlertDialog.alert('系統忙線中,請稍後再試');
            throw new Error('系統忙線中,請稍後再試');
          })
          .then((res) => {
            this.initPhotoArray();

            fireShopContentView({
              affiliation: res.Colors[this.colorIndex].Name,
              customMarketID: res.CustomMarketID,
              eventName: res.Events.length ? res.Events[0].Name : '',
              name: res.Name,
              price: res.EventPrice > 0 ? res.EventPrice : res.SellPrice,
            });
          })
          .catch(() => {
            AlertDialog.alert('系統忙線中,請稍後再試');
          });
      },
      initFavoriteState() {
        const colorData = this.theProductDataNew.Colors;
        const favoriteState = colorData.map((data) => data.IsFavorite);
        this.favoriteState = favoriteState;
      },
      initColorIndex() {
        const pageColorCode = window.CustomMarketID.substring(
          window.CustomMarketID.indexOf('CL') + 2,
          window.CustomMarketID.indexOf('SZ'),
        );

        let colorIndex = -1;

        for (let i = 0; i < this.theProductDataNew.Colors.length; i++) {
          if (this.theProductDataNew.Colors[i].ID === parseInt(pageColorCode)) {
            // 如果迴圈被中斷 代表Colors資料與網址相符
            colorIndex = i;
            break;
          }
          // 如果從頭到尾Colors沒有相符網址的八扣 就表示代表沒貨已下架
        }
        this.colorIndex = colorIndex;
        this.isFavorite = this.favoriteState[colorIndex];
        this.nowColorImage = this.theProductDataNew.Colors[colorIndex].Images[0].Url;
      },
      initPhotoArray() {
        // 整理圖片資料
        const colorData = this.theProductDataNew.Colors;
        let theColorPhotoAry = [];
        let theColorPhotoAry_new = [];
        let theColorZoomAry = [];
        let theColorStaffAry = [];
        let theColorStaffAry_new = [];
        let theColorStaffZoomAry = [];
        // 桌G版 需要整理圖片與 要放大圖片的陣列
        for (let i = 0, len = colorData.length; i < len; i++) {
          // 顏色
          theColorPhotoAry[i] = [];
          theColorPhotoAry_new[i] = [];
          theColorZoomAry[i] = [];

          theColorStaffAry[i] = [];
          theColorStaffAry_new[i] = [];
          theColorStaffZoomAry[i] = [];

          const colorImages_old = colorData[i].Images.map((data) => {
            if (data.Category === 0) {
              return data;
            } else {
              return null;
            }
          });

          const staffImages_old = colorData[i].Images.map((data) => {
            if (data.Category === 10) {
              return data;
            } else {
              return null;
            }
          });

          const colorImages = colorImages_old.filter((data) => data !== null);
          const staffImages = staffImages_old.filter((data) => data !== null);
          // 每個顏色下的每個模塊要顯示的中圖片在這
          theColorPhotoAry[i] = colorImages;
          theColorStaffAry[i] = staffImages;
          // 加入了要呈現的圖片

          // 開始處裡要放大的圖片的陣列
          const smallSuffix = this.photoSizeLogic.split('|')[0]; // 小圖尾綴
          const bigSuffix = this.photoSizeLogic.split('|')[1]; // 大圖尾綴
          const smallSuffix2 = this.photoSizeLogic_2.split('|')[0]; // 小圖尾綴
          const bigSuffix2 = this.photoSizeLogic_2.split('|')[1]; // 大圖尾綴
          // 顏色照片的放大
          for (let j = 0; j < colorImages.length; j++) {
            let photoUrl = colorImages[j].Url; // 完整URL(未編輯)
            if (photoUrl !== undefined) {
              // 如果不是undefined才要push
              // let photoUrl_small = imgTransfer(photoUrl,smallSuffix)
              // let photoUrl_zoom = imgTransfer(photoUrl,bigSuffix)
              let video_zoom = nowEnv.NowMyEquipment
                ? colorImages[j].VideoMUrl
                : colorImages[j].VideoUrl;
              theColorZoomAry[i].push(
                video_zoom !== undefined && video_zoom.length !== 0
                  ? imgTransfer(video_zoom, '')
                  : imgTransfer(colorImages[j].Url, ''),
              );
              // theColorPhotoAry_new[i].push(nowEnv.NowMyEquipment?photoUrl_small:photoUrl_zoom)
              theColorPhotoAry_new[i].push({
                imgUrl: imgTransfer(colorImages[j].Url, nowEnv.NowMyEquipment ? smallSuffix : ''),
                VideoUrl: imgTransfer(colorImages[j].VideoUrl, ''),
                VideoMUrl: imgTransfer(colorImages[j].VideoMUrl, ''),
              });
            }
          }

          for (let j = 0; j < staffImages.length; j++) {
            let photoUrl = staffImages[j].Url; // 完整URL(未編輯)
            if (photoUrl !== undefined) {
              // 如果不是undefined才要push
              let photoUrl_zoom = imgTransfer(photoUrl, bigSuffix);
              theColorStaffZoomAry[i].push(photoUrl);
              theColorStaffAry_new[i].push({
                imgUrl: staffImages[j].Url,
                VideoUrl: imgTransfer(staffImages[j].VideoUrl, ''),
                VideoMUrl: imgTransfer(staffImages[j].VideoMUrl, ''),
              });
            }
          }
        }

        this.theColorPhotoAry = theColorPhotoAry_new; // 要呈現的圖片們都已經整理好
        this.theColorZoomAry = theColorZoomAry; // 放大後輪播的陣列，由子輩ProductPhotos模快控制該陣列內容
        this.theColorStaffAry = theColorStaffAry_new; // 要呈現的圖片們都已經整理好
        this.theColorStaffZoomAry = theColorStaffZoomAry; // 放大後輪播的陣列，由子輩ProductPhotos模快控制該陣列內容
      },

      handleChangeFavoriteState(index) {
        this.favoriteState[index] = !this.favoriteState[index];
        this.isFavorite = this.favoriteState[this.colorIndex];
      },
      handleChangeColor(index) {
        // 修改當前瀏覽顏色序號
        const sizesData = this.theProductDataNew.Colors[index].Specs;
        let sizeIndex = -1;
        if (Array.prototype.findIndex) {
          sizeIndex = sizesData.findIndex((size) => size.Name === this.sizeName);
        } else {
          // support for ie
          for (let i = 0, len = sizesData.length; i < len; i++) {
            if (sizesData[i].Name === this.sizeName) {
              sizeIndex = i;
              break;
            }
          }
        }
        this.onChangeColor(index);
        this.onChangeSize(sizesData[sizeIndex]);

        this.colorIndex = index;
        this.colorID = this.theProductDataNew.Colors[index].ID;
        this.nowColorImage = this.theProductDataNew.Colors[index].Images[0].Url;
        this.barcode = sizeIndex === -1 ? '' : sizesData[sizeIndex].Barcode;
        this.sizeIndex = sizeIndex;
        this.buyAmount = 1;
        this.isFavorite = this.favoriteState[this.colorIndex];
        setTimeout(() => {
          $('.product-details').trigger('sticky_kit:recalc');
        }, 2000);

        // 如果是 Free Size
        if (sizesData[0].Name === 'F') {
          this.onChangeSize(sizesData[0]);
          this.handleChangeSize(sizesData[0].Barcode);
        }
      },
      onChangeColor(index) {
        this.updateSizeSelectOptions(index);
      },
      onChangeSize(sizeData) {
        this.checkIsPreOrderProduct(sizeData);
        this.updateTotalQty(sizeData);
        this.sizeData = sizeData;
        if (this.sizeData !== undefined) {
          this.sizeID = sizeData.Key;
        } else {
          this.sizeID = '';
        }

        this.colorID = this.theProductDataNew.Colors[this.colorIndex].ID;
      },
      updateTotalQty(sizeData) {
        const totalQty = $.isEmptyObject(sizeData)
          ? 0
          : sizeData.PreOrder && sizeData.Stock < 1
          ? sizeData.Stock
          : sizeData.Stock;
        this.totalQty = totalQty;
      },
      checkIsPreOrderProduct(sizeData) {
        const isPreOrderProduct = $.isEmptyObject(sizeData) ? false : sizeData.PreOrder;
        this.isPreOrderProduct = isPreOrderProduct;
      },
      handleChangeSize(barcode) {
        const sizesData = this.theProductDataNew.Colors[this.colorIndex].Specs;
        let sizeName;
        let sizeIndex;
        for (let i = 0, len = sizesData.length; i < len; i++) {
          if (sizesData[i].Barcode === barcode) {
            sizeName = sizesData[i].Name;
            sizeIndex = i;
            break;
          }
        }
        this.onChangeSize(sizesData[sizeIndex]);
        this.barcode = barcode;
        this.sizeName = sizeName;
        this.sizeIndex = sizeIndex;
        this.buyAmount = 1;
      },
      handleChangeAmount(amount) {
        this.buyAmount = amount;
      },
      createSizeSelectOptions(sizes) {
        return sizes.map((size) => {
          let text = size.Name;
          let isWeak = false;
          if (size.PreOrder) {
            text += ' (預)'; // 預購加字
          }
          if (size.Stock < 1) {
            isWeak = true;
          }

          return {
            value: size.Barcode,
            text,
            isWeak,
          };
        });
      },
      updateSizeSelectOptions(index) {
        this.sizeSelectOptions = this.createSizeSelectOptions(
          this.theProductDataNew.Colors[index].Specs,
        );
      },
      showSizeReport() {
        if (this.NowMyEquipment) {
          // 手機
          $(this.sizeReport).slideToggle();
        } else {
          $('#sizeGuide').modal('show');
        }
      },
      openPopup(popupName) {
        this.activeTabName = popupName;

        if (popupName === 'desc') {
          this.sizeReportOpened = false;
          this.careReportOpen = false;

          if (window.nowEnv.NowMyEquipment) {
            $('#mobile-report-content').slideUp('fast');
            $('#mobile-report-care').slideUp('fast');
          }
        }

        if (popupName === 'care') {
          this.careReportOpen = !this.careReportOpen;

          if (window.nowEnv.NowMyEquipment) {
            this.toggleCareContent();
            return;
          }
          $('#size-care').modal('show');
        }

        if (popupName === 'size') {
          $('.size-guide__section').each(function () {
            if (!$(this).find('td').length) $(this).hide();
          });

          if (window.nowEnv.NowMyEquipment) {
            this.toggleContent();
            return;
          }

          $('#size-report').modal('show');

          if (!this.sizeReportOpened) {
            $('.size-guide__content').hide();
            $('.size-guide').find('.size-guide__content').eq(0).show();
            $('.size-guide__section > h2').click(function () {
              $(this)
                .parents('.size-guide__section')
                .siblings()
                .find('.size-guide__content')
                .slideUp();
              $(this).parents('.size-guide__section').find('.size-guide__content').slideToggle();
            });
            this.sizeReportOpened = true;
          }
        }
      },
      toggleContent() {
        this.sizeReportOpened = !this.sizeReportOpened;
        this.careReportOpen = false;

        if (this.sizeReportOpened) {
          $('#mobile-report-care').slideUp('fast');
          $('#mobile-report-content').slideDown('fast');
        } else {
          $('#mobile-report-content').slideUp('fast');
        }
      },
      toggleCareContent() {
        this.sizeReportOpened = false;

        if (this.careReportOpen) {
          $('#mobile-report-content').slideUp('fast');
          $('#mobile-report-care').slideDown('fast');
        } else {
          $('#mobile-report-care').slideUp('fast');
        }
      },
    },
    template: /*html*/ `
    <div :class="theColorPhotoAry.length > 0?'product-content-wrap':'product-content-wrap loading'">
    <div id="size-report" class="modal fade" tabindex="-1">
        <div class="modal-dialog" role="document" style="max-width:800px">
            <div class="modal-content">
                <div class="modal-header">
                    <a href="#" data-dismiss="modal" class="r-lightbox__close"></a>
                </div>
                <div class="modal-body">
                    <div v-html="theProductDataNew.SizeReport"></div>
                </div>
            </div>
        </div>
      </div>
    <div id="size-care" class="modal fade" tabindex="-1">
        <div class="modal-dialog" role="document" style="max-width:800px">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="care-title">CARE 商品保養</p>
                    <a href="#" data-dismiss="modal" class="r-lightbox__close"></a>
                </div>
                <div class="modal-body"> 
                    <div v-html="theProductDataNew.CareLabelDesc"></div>
                </div>
            </div>
        </div>
    </div>
    <div id="productArea">
        <div class="product-photos">
            <Photos v-if="!NowMyEquipment && theColorPhotoAry.length > 0"
                :specifyClassName="NowMyEquipment ? 'product-photos__jumbo' : 'product-photos__images'"
                :nowColorPhotoAry="theColorPhotoAry[colorIndex]" :sizeLogic=photoSizeLogic
                :NowMyEquipment=NowMyEquipment :zoom="true" :nowColorZoomAry="theColorZoomAry[colorIndex]" />
            <Photos v-if="NowMyEquipment && theColorPhotoAry.length>0"
                :specifyClassName="NowMyEquipment ? 'product-photos__jumbo' : 'product-photos__images'"
                :nowColorPhotoAry="theColorPhotoAry[colorIndex].slice(0, 1)" :sizeLogic="photoSizeLogic"
                :NowMyEquipment="NowMyEquipment" :zoom="true" :nowColorZoomAry="theColorZoomAry[colorIndex]" />
            <Recommend v-if="!NowMyEquipment" :product-name="productName" />
        </div>
        <div class='product-details'>
            <div class='product-info'>
                <h1 class='product-title'>{{productName}}</h1>
                <h2 class='product-title-en'>{{subtitle}}</h2>
                <div class='note'
                    v-if='theProductDataNew.IsLimitedRefund || theProductDataNew.IsForeginDeliver || theProductDataNew.IsOffshoreIsland'>
                    <span class='note' v-if='theProductDataNew.IsLimitedRefund'>此商品無提供退換貨</span>
                    <template v-if='!theProductDataNew.IsForeginDeliver && !theProductDataNew.IsOffshoreIsland'>
                        <span>此商品不支援「海外/離島」配送服務</span>
                    </template>
                    <template v-else>
                        <span v-if='!theProductDataNew.IsForeginDeliver'>此商品不支援「海外」配送服務</span>
                        <span v-if='!theProductDataNew.IsOffshoreIsland'>此商品不支援「離島」配送服務</span>
                    </template>
                </div>
            </div>
            <Price :productData="theProductDataNew" v-if="theColorPhotoAry.length>0" />
            <p v-if="bonusText" class="shop-bonus-text">限時回饋：一般會員 5% VIP 7% VVIP 10%</p>
            <div v-if="isPreOrderProduct">
                <div class='product-PreoderDAY'>
                    <span class='date'>{{theProductDataNew.ArrivalExplanation}}</span>
                </div>
            </div>
            <hr />
            <div class='product-color'>
                <span class='product-color__current' v-if="theProductDataNew.Colors">
                    {{theProductDataNew.Colors[colorIndex].Name}}
                </span>
                <div class='product-barcode'>
                    {{barcode || '尚未選擇尺寸'}}
                </div>
                <ColorButton v-if="theProductDataNew.Colors" :productColorsData="theProductDataNew.Colors"
                    :colorIndex="colorIndex" v-on:handleChangeColor="handleChangeColor" />
            </div>
            <p v-if='totalQty!==0&&totalQty<10' class="solid-out-text my-2">即將售完</p>
            <Select :options="sizeSelectOptions" :nowValue="barcode" :nowText="nowText" defaultText='SIZE'
                v-on:onChangeValue="handleChangeSize" id='sizeSelect' :class="{'r-select-radio': NowMyEquipment}"
                :isDropDown="!NowMyEquipment" />
            <Quantity :limit="!!theProductDataNew.Limit?theProductDataNew.Limit:totalQty" :nowValue="buyAmount"
                v-on:onChangeAmount="handleChangeAmount" />
            <div class='BuyAndWish'>
                <BuyButton v-if="theProductDataNew.CustomMarketID" :CustomMarketID="theProductDataNew.CustomMarketID"
                    :barcode="barcode" :productName="productName"
                    :productColor="theProductDataNew.Colors[colorIndex].Name" :sizeName="sizeName"
                    :buyAmount="buyAmount" :sizeData="sizeData"
                    :onSaleCode="theProductDataNew.Events.length > 0 ? theProductDataNew.Events[0].ID : ''"
                    :sellingPrice="theProductDataNew.SellPrice" :eventPrice="theProductDataNew.EventPrice"
                    :originPrice="theProductDataNew.OriginPrice"
                    :isCosmetic="theProductDataNew.IsCosmetic"
                    :extendText="theProductDataNew.IsCosmetic ? {askNotice: '謝謝支持 ♡ 已全數完售'} : null"
                    :memberID="theProductDataNew.MemberSN" :colorID="colorID" :sizeID="sizeID"
                    :linkUrl="theProductDataNew.Colors[colorIndex].MarketUrl"
									  :imgUrl="theProductDataNew.Colors[colorIndex].Images[0].Url"
										:productImage="nowColorImage"
                    :isPreShow="theProductDataNew.IsPreShow" @reRenderCart="carAddMainItem = true" />
                <WhishlistBtn 
                    v-if="theProductDataNew.CustomMarketID"
                    :CustomMarketID="theProductDataNew.CustomMarketID" 
                    :colorID="colorID" 
                    :colorIndex="colorIndex"
                    :isFavorite="isFavorite"
                    :selectedColor="theProductDataNew.Colors[colorIndex].Name"
                    :productName="productName"
                    :productSellPrice="theProductDataNew.EventPrice > 0 ? theProductDataNew.EventPrice : theProductDataNew.SellPrice"
                    :sizeName="sizeName"
                    @handleChangeFavoriteState="handleChangeFavoriteState" />
            </div>
            <div class='product-summary'>
                <ul class='d-none d-sm-block tabs__nav'>
                    <li :class="{'tag':activeTabName === 'desc'}">
                      <button class="btn" @click.prevent="openPopup('desc')">DESCRIPTION商品描述</button>
                    </li>
                    <li :class="{'tag':activeTabName === 'size'}">
                      <button class="btn" @click.prevent="openPopup('size')">SIZE GUIDE尺寸指南</button>
                    </li>
                    <li :class="{'tag':activeTabName === 'care'}">
                      <button class="btn" @click.prevent="openPopup('care')">CARE商品保養</button>
                    </li>
                </ul>
                <ul class='d-sm-none tabs__nav'>
                  <li :class="{'tag':activeTabName === 'desc'}">
                    <button class="btn" @click.prevent="openPopup('desc')">商品描述</button>
                  </li>
                  <li :class="{'tag':activeTabName === 'size'}">
                    <button class="btn" @click.prevent="openPopup('size')">尺寸指南</button>
                  </li>
                  <li :class="{'tag':activeTabName === 'care'}">
                    <button class="btn" @click.prevent="openPopup('care')">商品保養</button>
                  </li>
                </ul>
                <div id="mobile-report-content" class="hide" v-if="NowMyEquipment"
                    v-html="theProductDataNew.SizeReport">
                </div>
                <div id="mobile-report-care" class="hide" v-if="NowMyEquipment"
                    v-html="theProductDataNew.CareLabelDesc">
                </div>
                <div class='tabs__content'>
                    <div v-show="activeTabName === 'desc'">
                        <p>*實品顏色依單品照為主</p>
                        <p v-html="theProductDataNew.MaterialDescription"></p>
                        <p>{{'素材產地 / ' + theProductDataNew.MaterialOriginDescription}}</p>
                        <p>{{'加工產地 / ' + theProductDataNew.OriginDescription}}</p>
                        <p v-html="theProductDataNew.Description"></p>
                    </div>
                    <ootd v-if="theColorStaffAry[colorIndex] !== undefined &&  theColorStaffAry[colorIndex].length > 0"
                        :h4Title="'how to wear'" :ootdData="theColorStaffAry[colorIndex]" :colorIndex="colorIndex"
                        :allOotdData="theColorStaffAry" :sizeLogic="'s|'" :slick="!NowMyEquipment" :showQuantity="3"
                        :zbClass="'zb-ootd'" :className="'product-photos__slider'" :arrows="false"
                        :picSize="'_w310_h389'"
                        :blankPicUrl="'https://static.tpx.tw/sff/meierq/static/img/img-blank-photo-s.png'"
                        :slidesToShow="3">
                    </ootd>
                    <div>
                    </div>
                </div>
            </div>
            <Photos
              class="mb-4"
              v-if="NowMyEquipment && theColorPhotoAry.length > 0"
              :specifyClassName="
                NowMyEquipment ? 'product-photos__jumbo' : 'product-photos__model'
              "
              :nowColorPhotoAry="theColorPhotoAry[colorIndex]"
              :sizeLogic="photoSizeLogic"
              :NowMyEquipment="NowMyEquipment"
              :zoom="true"
              :nowColorZoomAry="theColorZoomAry[colorIndex]"
            />
            <Addon :marketID="CustomMarketID" :carAddMainItem="carAddMainItem" />
            <Recommend v-if="NowMyEquipment" :product-name="productName" />
        </div>
    </div>
</div>`,
  });
}

export default RenderProductPageContent;
